import * as React from 'react';

import EventsFilterValueRenderers from 'components/events/FilterValueRenderers';
import { OwnerCell, CategoryCell } from 'security-app/components/SecurityEvents/Alerts/ColumnRenderers';

const FilterValueRenderers = {
  ...EventsFilterValueRenderers,
  owner: (value: string) => <OwnerCell owner={value} />,
  category: (value: string) => <CategoryCell category={value} />,
};

export default FilterValueRenderers;
